import fetch from '@/util/fetch'

export function loginByUsername(username, password) {
	const data = {
		'account': username,
		'password': password,
	}
	return fetch({
		url: '/auth/user/login',
		method: 'post',
		params: data
	})
}

export function logout() {
	return fetch({
		url: '/login/logout',
		method: 'post'
	})
}

export function getUserInfo(token) {
	return fetch({
		url: '/sysUser/read/detail',
		method: 'get',
		params: {
			token
		}
	})
}


// WEBPACK FOOTER //
// ./src/api/login.js